import React, { Component, PropTypes } from 'react';


class About extends Component {
  render() {
    return(
      <div><h1> Under Construction... </h1></div>
    )
  }
}

export default About;
